/**
 * ResearchToggleButtonContainer component
 * Container component for the research toggle button that passes through props to the view.
 * This component currently has no logic as all state is managed by the parent component.
 */

import React from "react";

import ResearchToggleButtonView, {
  ResearchToggleButtonViewProps,
} from "./ResearchToggleButtonView";

/**
 * Props for the ResearchToggleButtonContainer component
 * Matches the View props as this is a passthrough container
 */
export type ResearchToggleButtonContainerProps = ResearchToggleButtonViewProps;

/**
 * Container component for the research toggle button
 * Currently a passthrough component that delegates all logic to parent
 * @param props - Component props
 */
const ResearchToggleButtonContainer = (
  props: ResearchToggleButtonContainerProps
) => <ResearchToggleButtonView {...props} />;

export default ResearchToggleButtonContainer;
